
import { AttributeValue } from "../../../library-js/dom-tools/AttributeValue";
import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { Events, OnChange, OnClick, OnMouseDown, OnSelectStart } from "../../../library-js/dom-tools/EventListeners";
import { HTMLEditor } from "../../../library-js/dom-tools/HTMLEditor";
import { InspectorContainer } from "../containers/InspectorContainer";
import { InspectorField } from "./InspectorField";

export class ContainerField extends InspectorField<any>
{
  static readonly type = new ElementType( "container--field" );
  static readonly adderBlock = new ElementType( "adder--block" );
  static readonly adder = new ElementType( "adder--button" );

  static _openFields = new Map<string,Set<string>>();

  static setFieldOpen( field:InspectorField<any> )
  {
    if ( ! this._openFields.has( field.memberName ) )
    {
      this._openFields.set( field.memberName, new Set<string>() );
    }

    let set = this._openFields.get( field.memberName );
    set.add( field.fieldPath );
  }

  static setFieldClosed( field:InspectorField<any> )
  {
    if ( ! this._openFields.has( field.memberName ) )
    {
      return;
    }

    let set = this._openFields.get( field.memberName );

    set.delete( field.fieldPath );

  }

  static setFieldOpenState( field:InspectorField<any>, isOpen:boolean )
  {
    if ( isOpen )
    {
      this.setFieldOpen( field );
    }
    else
    {
      this.setFieldClosed( field );
    }
  }

  static isFieldOpen( field:InspectorField<any> )
  {
    if ( ! this._openFields.has( field.memberName ) )
    {
      return false;
    }

    let set = this._openFields.get( field.memberName );

    return set.has( field.fieldPath );
  }
  
  addAdder()
  {  
    let childContainer = InspectorContainer.containerChildren.query( this.container ); 
    
    let adderButton = ContainerField.adder.create( "+" );
    let adderBlock = ContainerField.adderBlock.create( adderButton );

    childContainer.appendChild( adderBlock );

    return adderButton;
  }

  addOpener()
  {
    let opener = InspectorContainer.containerOpener.query( this.container );
    HTMLEditor.setText( opener, InspectorField.closeText );

    let toggleOpenState =  ()=>
    {   
      let text   = opener.innerHTML;
      let isOpen = InspectorField.openText === text;

      isOpen = ! isOpen;

      text = isOpen ? InspectorField.openText : InspectorField.closeText;
      HTMLEditor.setText( opener, text );

      ClassFlag.open.setAs( this.container, isOpen );

      ContainerField.setFieldOpenState( this, isOpen );

     };

    OnClick.add( opener as HTMLElement, toggleOpenState );

    let name = InspectorContainer.containerName.query( this.container );

    OnClick.add( name as HTMLElement, toggleOpenState );

    Events.disableSelection( opener as HTMLElement );
    Events.disableSelection( name as HTMLElement );

    if ( ContainerField.isFieldOpen( this ) )
    {
      toggleOpenState();
    }
  }

  onAddedToContainer()
  {
    this.addOpener();
  }
  
  createElement() 
  {

    //let container = InspectorContainer.type.query( 
    //let opener  = InspectorField.opener.create( InspectorField.closeText );
    let element = ContainerField.type.create();
    InspectorField.flag.set( element );
    
    this._element = element;

    /*
    OnClick.add( opener as HTMLElement, 
      ( e )=>
      {   
        let text   = opener.innerHTML;
        let isOpen = InspectorField.openText === text;

        isOpen = ! isOpen;

        text = isOpen ? InspectorField.openText : InspectorField.closeText;
        HTMLEditor.setText( opener, text );

        let container = InspectorContainer.type.getParent( element );
        ClassFlag.open.setAs( container, isOpen );        
      } 
    );

    Events.disableSelection( opener as HTMLElement );
    */
  }

  syncValueToElement()
  {
    
  }
  
  
} 